<template>
  <header>
    <transition name="logo">
      <h2 id="logo" v-if="!hasScrolled">
        Paul Jobard
      </h2>
    </transition>
    <ul id="menu" v-bind:class="{ scroll: hasScrolled }">
      <li><router-link to="/projets">Projets</router-link></li>
      <li><router-link to="/expertise">À propos</router-link></li>
      <li><router-link to="/contact">Contact</router-link></li>
    </ul>
  </header>
</template>
<script>
export default {
  data() {
    return {
      hasScrolled: false
    };
  },
  methods: {
    handleScroll() {
      if (window.scrollY == 0) {
        this.$data.hasScrolled = false;
      } else {
        this.$data.hasScrolled = true;
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
